import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useCheckableStyles = createStyles(() => ({
  checkableGroupVertical: {
    display: 'block',

    '.ant-checkbox-group-item': {
      display: 'block',
      marginRight: 0,
    },
    '.ant-radio-wrapper, .ant-checkbox-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      marginRight: 0,
      lineHeight: 1,

      '& + .ant-radio-wrapper, & + .ant-checkbox-wrapper': {
        marginTop: ThemeSpaces.SPACE_NORM,
      },
    },

    '.ant-radio, .ant-checkbox': {
      marginRight: ThemeSpaces.SPACE_NORM,
    },
  },
}));
